const getBaseName = () => {
  return import.meta.env.DEV ? 
    import.meta.env.VITE_BASENAME_DEV :
    import.meta.env.VITE_BASENAME_PROD;
};

const getMode = () => {
  return import.meta.env.DEV ? 'test' : 'live';
};

export const getDasboardReport = (kind: 'pivot' | 'sex' | 'age'): number => {
  switch (kind) {
    case 'pivot':
      return import.meta.env.VITE_dashboard_report_pivot;
    case 'sex':
      return import.meta.env.VITE_dashboard_report_sex;
    case 'age':
      return import.meta.env.VITE_dashboard_report_age;
  };
};

// export const basename: string = getBaseName();
export const basename: string = '';
export const mode: string = getMode();

